export const formatTime = (minutesWithFractions) => {
  const minutes = Math.ceil(minutesWithFractions);
  const hours = Math.floor(minutes / 60);
  const formattedHours = Math.abs(hours).toString().padStart(2, '0');
  const formattedMinutes = Math.abs(minutes % 60).toString().padStart(2, '0');
  const sign = minutesWithFractions < 0 ? '-' : '';
  return `${sign}${formattedHours}:${formattedMinutes}`;
};

export const parseTime = (time) => {
    const [hours, minutes] = time.split(':').map((part) => parseInt(part, 10));
    return hours * 60 + minutes;
};

